import { submitUpdatePlayerSubscription } from "@/helpers/api/player-subscription/update";
import { ref, watch } from "vue";
import { useForm } from "vee-validate";
import * as yup from 'yup';
import { useLiveStream } from "./liveStream";
  // TODO: to think about: moving "data" out of here into the parent caller and make it passed via "submitForm" function

export function useSaveLiveStreamFormHelpers() {
  // TODO (Cleanup): consider merging similarities between useSaveLiveStreamFormHelpers and useSavePlayerSubscriptionFormHelpers
  const { data, prepareDataForSubmission } = useLiveStream();

  const isLoading = ref(false);
  const isSuccess = ref(false);
  const isError = ref(false);
  const errorMessage = ref("");

  const validationSchema = yup.object({
    name: yup.string().label('Name').required(),
    organizations: yup.array().label('Organizations').min(1, 'At least one organization is required')
  });

  const initialValues = {
    name: "",
    organizations: []
  };

  watch(data, () => {
    // update form values on data change;
    values.name = data.name;
    values.organizations = data.filters.organizations
  })
  const { errors, handleSubmit, values, setValues, isSubmitting } = useForm({ validationSchema, initialValues });
  
  const submitForm = handleSubmit(handleValidFormSubmit, handleInvalidFormSubmit);

  async function handleValidFormSubmit() {
    try {
      errorMessage.value = "";
      isLoading.value = true;
      const dataToSubmit = await prepareDataForSubmission(data);
      const submissionResponse = await submitUpdatePlayerSubscription(dataToSubmit);
      isLoading.value = false;
      if (submissionResponse.success === true) {
        // if is successful
        isSuccess.value = true;
      } else {
        console.error('Error in saving player subscription response', submissionResponse.errors)
        throw new Error("Unable to save player subscription!")
      }
    } catch (error) {
      console.error('Error while saving player subscription', error)
      isError.value = true;
      isLoading.value = false;
      errorMessage.value = `Something went wrong. (${error})`;
    }
  }

  async function handleInvalidFormSubmit() {
    let errorsAugmentedInSingleMessage = "";
    // TODO (cleaner code): think if there's a cleaner way to write this [DSP-N26Cti4A]
    if(Object.keys(errors.value).length){
      Object.keys(errors.value).forEach((key) => {
        errorsAugmentedInSingleMessage += errors.value[key]+". ";
      });
    }
    errorMessage.value = errorsAugmentedInSingleMessage;
  }

  return {
    values,
    submitForm,
    isError,
    isSuccess,
    isLoading,
    errorMessage,
  };
}